<li tabindex="0" class="action-plan-topic-response" data-id="{{id}}" data-response-count="{{response_count}}">
  <span class="topic-name">{{name}}</span>

  {{#if anyActionPlanItemResponses}}
    <ul class="action-plan-items" role="region">
      {{#each action_plan_items_collection}}
        <li class="action-plan-item" data-id="{{id}}" data-response-state="{{actionPlanItemResponse.state}}" data-response-id="{{actionPlanItemResponse.id}}">

          <div class="title-wrapper">
            <span role="button" class="item-info" {{#unless actionPlanItemResponse.state}} tabindex="0" {{/unless}}></span>
            <span class="title">{{{title}}}</span>
            {{#if actionPlanItemResponse.now}}
              <a href="#" role="button" class="response-state-link" data-state="later"></a>
            {{/if}}
            {{#if actionPlanItemResponse.later}}
              <a href="#" role="button" class="response-state-link" data-state="now"></a>
            {{/if}}
            {{#unless actionPlanItemResponse.done}}
              <a href="#" role="button" class="response-state-link" data-state="done"></a>
            {{/unless}}
          </div>
          {{#if actionPlanItemResponse.done}}
            <div class="done"></div>
          {{/if}}

          <div class="action-plan-item-feedback" data-id="{{id}}" role="alert" aria-live="polite">
            <div class="content">
              <span class="title">{{{title}}}</span>
              <p class="body">
                {{{body}}}
                {{#if other}}
                  <p class="other">{{actionPlanItemResponse.other_response}}</p>
                {{/if}}
              </p>
            </div>
          </div>

        </li>
      {{/each}}
    </ul>
  {{/if}}

</li>
